import { Pipe, PipeTransform } from '@angular/core';
import { SelectedSubProductCategoryDto } from '@warema/shared/models';

@Pipe({
    name: 'productsFilteredByCategory',
})
export class ProductsFilteredByCategoryPipe implements PipeTransform {
    public transform(
        productSubcategories: Array<SelectedSubProductCategoryDto>,
        categoryPrefix: string,
    ): Array<string> {
        return productSubcategories.filter(x => x.id.toString().startsWith(categoryPrefix)).map(y => y.name ?? '');
    }
}
